(function () {

    var module = angular.module('uwAgenda.programinfo');
    module.controller('ProgramInfoReadController', ['$window', '$uibModalInstance', '$sce', 'info', 'ProgramInfoService', ProgramInfoReadControllerFn]);

    // Read info screen notification modal controller
    function ProgramInfoReadControllerFn($window, $uibModalInstance, $sce, info, ProgramInfoService) {

        /* jshint validthis:true */
        var vm = this;

        vm.abort = abort;
        vm.markAsUnread = markAsUnread;
        vm.mailToUser = mailToUser;
        vm.openLinkInNewTab = openLinkInNewTab;

        // object to show
        vm.infoSafe = { title: '', subTitle: '', content: '' };

        activate();

        // activate controller
        function activate() {
            vm.infoSafe.title = info.title;
            vm.infoSafe.subTitle = info.subTitle;
            vm.infoSafe.hyperLink = info.hyperLink;
            vm.infoSafe.content = $sce.trustAsHtml(info.content);

            vm.infoSafe.readByCurrentUser = info.readByCurrentUser;

            markAsRead();
        }       

        // abort, dismiss modal
        function abort() {
            $uibModalInstance.dismiss('cancel');
        }

        function openLinkInNewTab(event, hyperLink) {
            event.stopPropagation();
            event.preventDefault();

            $window.open(hyperLink, '_blank');
        }
        
        function markAsRead() {
            return ProgramInfoService.readByUser(info.id, true)
        }

        function markAsUnread() {
            return ProgramInfoService.readByUser(info.id, false).then(function () {
                $uibModalInstance.close();
            });
        }

        // mail info notification to user
        function mailToUser() {
            ProgramInfoService.mailToUser(info.id).then(function () {
                $uibModalInstance.close("Program Info sent by mail");
            });
        }

    }

})();